import * as React from 'react';
export const Circle = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12 0a12 12 0 100 24 12 12 0 100-24z" />
  </svg>
);
